var map = {
	"./Arena.json": 1659,
	"./EmpressIcon.json": 7300,
	"./History.json": 9868,
	"./History2.json": 7406,
	"./Index.json": 1352,
	"./Island1/-Background.json": 8756,
	"./Island1/Animation.json": 7297,
	"./Island1/Background.json": 5945,
	"./Island1/Game.json": 5455,
	"./Island1/QnaFill.json": 1720,
	"./Island1/QnaMatch.json": 8818,
	"./Island1/QnaMc.json": 6421,
	"./Island1/QnaSort.json": 5325,
	"./Island1/Trivia.json": 7242,
	"./Island2/Animation.json": 6816,
	"./Island2/Background.json": 5758,
	"./Island2/Game.json": 40,
	"./Island2/QnaFill.json": 9849,
	"./Island2/QnaMatch.json": 6265,
	"./Island2/QnaMc.json": 1560,
	"./Island2/QnaSort.json": 2408,
	"./Island2/Trivia.json": 7541,
	"./Island3/Animation.json": 883,
	"./Island3/Background.json": 9895,
	"./Island3/Game.json": 9669,
	"./Island3/QnaFill.json": 2990,
	"./Island3/QnaMatch.json": 8052,
	"./Island3/QnaMc.json": 2163,
	"./Island3/QnaSort.json": 9915,
	"./Island3/Trivia.json": 3460,
	"./Island4/Animation.json": 2178,
	"./Island4/Background.json": 4732,
	"./Island4/Game.json": 9606,
	"./Island4/QnaFill.json": 119,
	"./Island4/QnaMatch.json": 3715,
	"./Island4/QnaMc.json": 4430,
	"./Island4/QnaSort.json": 6350,
	"./Island4/Trivia.json": 4167,
	"./Island5/Animation.json": 5197,
	"./Island5/Background.json": 1805,
	"./Island5/Game.json": 7619,
	"./Island5/IndexIcon.json": 626,
	"./Island5/QnaFill.json": 9788,
	"./Island5/QnaMatch.json": 1750,
	"./Island5/QnaMc.json": 5033,
	"./Island5/QnaSort.json": 1337,
	"./Island5/Trivia.json": 5990,
	"./Island6/Animation.json": 2124,
	"./Island6/Background.json": 8434,
	"./Island6/Game.json": 5596,
	"./Island6/GameTrivia.json": 8395,
	"./Island6/IndexIcon.json": 2863,
	"./Island6/QnaFill.json": 2365,
	"./Island6/QnaMatch.json": 6061,
	"./Island6/QnaMc.json": 3996,
	"./Island6/QnaSort.json": 6228,
	"./Island6/Trivia.json": 5297,
	"./Island7/Animation.json": 1839,
	"./Island7/Background.json": 5915,
	"./Island7/Game.json": 697,
	"./Island7/GameTrivia.json": 8522,
	"./Island7/IndexIcon.bak.json": 7096,
	"./Island7/IndexIcon.json": 5248,
	"./Island7/QnaFill.json": 5442,
	"./Island7/QnaMatch.json": 360,
	"./Island7/QnaMc.json": 3367,
	"./Island7/QnaSort.json": 4071,
	"./Island7/Trivia.json": 2912,
	"./Island8/Animation.json": 7998,
	"./Island8/Background.json": 7344,
	"./Island8/Game.json": 2618,
	"./Island8/IndexIcon.json": 1885,
	"./Island8/QnaFill.json": 5387,
	"./Island8/Trivia.json": 6096,
	"./Island9/Animation.json": 7817,
	"./Island9/Background.json": 6289,
	"./Island9/Game.json": 7847,
	"./Island9/IndexIcon.json": 6942,
	"./Island9/QnaFill.json": 0,
	"./Island9/Trivia.json": 7954,
	"./battleicon.json": 4435,
	"./chinesemilitary.json": 8988,
	"./historyicon.json": 6529,
	"./login-background.json": 3504,
	"./papermaking.json": 2199,
	"./warringstates.json": 7578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 839;